<div>
  <!-- <div class="backg">
    <img src="assets/Serina Assets/new_theme/OD4FW00.png" alt="theme" />
    <div class="secondary_icon">
      <img [src]="data?.icon" alt="close" />
    </div>
  </div> -->
  <div class="head" [ngStyle]="{
    'background-color': type == 'delete' ? '#D80000' : 
                        type == 'normal' ? '#2786BD' : 
                        type == 'info' ? '#2786BD' : '#2786BD'
  }">
    <i *ngIf="type == 'delete'" class="fa fa-trash-o" aria-hidden="true"></i>
    <img *ngIf="type == 'normal'" src="assets/Serina Assets/new_theme/question.png" alt="imageUrl" width="28" height="28" />
    <i *ngIf="type == 'info'" class="fa fa-info-circle" aria-hidden="true"></i>
  </div>
  <div class="dialog_text f-16">
    <div class="f-13 poppins-semibold text-center">{{ componentTxt }}</div>
  </div>

  <div class="mr-3 d-flex justify-content-center">
    <button
      class="secondary_btn btns f-12 mr-2"
      type="button"
      (click)="closedialog(false)"
    >
      <span *ngIf="typeOfDialog != 'poStatus'">{{
        typeOfDialog == "confirmation" ? "No" : "Ok"
      }}</span>
      <span *ngIf="typeOfDialog == 'poStatus'"> Close </span>
    </button>
    <button
      cdkFocusInitial 
      *ngIf="typeOfDialog == 'confirmation' || typeOfDialog == 'poStatus'"
      class="primary_btn btns f-12"
      type="submit"
      (click)="closedialog(true)"
    >
      <span *ngIf="typeOfDialog != 'poStatus'">{{
        typeOfDialog == "confirmation" ? "Yes" : "Ok"
      }}</span>
      <span *ngIf="typeOfDialog == 'poStatus'"> View Details </span>
    </button>
  </div>
</div>
